<div class="social-actions">
  <div (click)="tabNavigation.gotDeeperInTab('favoriten')" class="social-actions__action" *ngIf="hasFavorites">
    <span class="icon-heart-full"></span>
  </div>
</div>
